import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Search, Menu, X, Bell, User as UserIcon } from "lucide-react";
import { Logo } from "./Brand";
import { useAuth, homeForRole } from "../lib/auth";
import Marquee from "./Marquee";

const NAV = [
  { label: "Live", path: "/" },
  { label: "Archive", path: "/library" },
  { label: "Picks", path: "/picks" },
  { label: "Artists", path: "/artists" },
  { label: "Events", path: "/events" },
  { label: "Shop", path: "/shop" },
  { label: "Slots", path: "/slots" },
  { label: "Guide", path: "/guide" },
];

export default function PublicLayout({ children }) {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0C] text-[#F4F4F5]">
      <header className="glass-nav sticky top-0 z-50">
        <div className="mx-auto max-w-[1600px] px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Logo size={40} />
          <nav className="hidden lg:flex items-center gap-7">
            {NAV.map((n) => (
              <Link key={n.path} to={n.path} data-testid={`nav-${n.label.toLowerCase()}`}
                className="mono-label text-[#A1A1AA] hover:text-[#E8552A] transition-colors">
                {n.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-2 sm:gap-3">
            <Link to="/dj" data-testid="dj-portal-link" className="hidden md:block mono-label text-[#A1A1AA] hover:text-[#E8552A]">FOR DJS</Link>
            <button data-testid="search-btn" onClick={() => nav("/library")} className="p-2 text-[#A1A1AA] hover:text-[#E8552A]"><Search size={18} /></button>
            {user ? (
              <div className="flex items-center gap-2">
                <Link to="/notifications" data-testid="notifications-link" className="p-2 text-[#A1A1AA] hover:text-[#E8552A]"><Bell size={18} /></Link>
                <Link to={homeForRole(user.role)} data-testid="account-link"
                  className="hidden sm:flex items-center gap-2 mono-label text-[#F4F4F5] border border-[#27272A] rounded-full px-3 py-1.5 hover:border-[#E8552A]">
                  <UserIcon size={14} /> {user.name?.split(" ")[0] || "ACCOUNT"}
                </Link>
                <button data-testid="logout-btn" onClick={() => { logout(); nav("/"); }} className="hidden sm:block mono-label text-[#71717A] hover:text-[#E8552A]">LOGOUT</button>
              </div>
            ) : (
              <>
                <Link to="/login" data-testid="signin-link" className="mono-label text-[#F4F4F5] hover:text-[#E8552A] px-2">SIGN IN</Link>
                <Link to="/membership" data-testid="become-member-button" className="copper-btn rounded-full px-4 py-2 mono-label hidden sm:block">BECOME A MEMBER</Link>
              </>
            )}
            <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} className="lg:hidden p-2 text-[#F4F4F5]">{open ? <X size={22} /> : <Menu size={22} />}</button>
          </div>
        </div>
        {open && (
          <div className="lg:hidden border-t border-[#27272A] bg-[#0A0A0C] px-4 py-4 space-y-3">
            {NAV.map((n) => (
              <Link key={n.path} to={n.path} onClick={() => setOpen(false)} className="block mono-label text-[#A1A1AA] hover:text-[#E8552A]">{n.label}</Link>
            ))}
            <Link to="/dj" onClick={() => setOpen(false)} className="block mono-label text-[#A1A1AA]">FOR DJS</Link>
            {!user && <Link to="/membership" onClick={() => setOpen(false)} className="block copper-btn rounded-full px-4 py-2 mono-label text-center">BECOME A MEMBER</Link>}
          </div>
        )}
      </header>
      <Marquee />
      <main>{children}</main>
      <footer className="border-t border-[#27272A] mt-20 py-10 px-6">
        <div className="mx-auto max-w-[1600px] flex flex-col sm:flex-row justify-between gap-6">
          <Logo size={44} />
          <div className="mono-label text-[#71717A] max-w-md leading-relaxed">
            A PLATFORM FOR DJS — FEEL THE MUSIC — FEEL THE SOUL · BROADCASTING FROM BANGALORE ·
            © {new Date().getFullYear()} RAV3.LABS-STUDIO
          </div>
        </div>
      </footer>
    </div>
  );
}
